import React from 'react';
import { Typography } from 'antd';
import PageTopWrapper from './page-top-wrapper';
import { Column } from '@ant-design/charts';

interface IProps {
    dataReport: any;
}

const LineChart: React.FC<IProps> = ({ dataReport }) => {
    const config = {
        data: dataReport?.dataReportOrderFinish || [],
        xField: 'name',
        yField: 'value',
        xAxis: {
            label: {
                autoHide: true,
                autoRotate: true,
            },
        },

        meta: {
            value: { alias: 'Lượt đặt phòng' },
        },
        minColumnWidth: 30,
        maxColumnWidth: 30,
    };
    return (
        <div className="div-status-chart">
            <PageTopWrapper leftContent={<Typography.Title level={5}>Lượt checkin theo thời gian</Typography.Title>} />
            <Column {...config} className="chart-status" />
        </div>
    );
};

export default LineChart;
